/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();
